import React, { useState, useEffect, useRef } from 'react';
import { errorCallback, makeUrl, SETUP_TAB_CUSTOMER, SETUP_TAB_DELIVERY, SETUP_TAB_NOTIFICATIONS, SETUP_TAB_PROFILE } from '../const/const';
import { getFetchRequest, GET_CURRENT_USER } from '../store/requests';
import TabCustomer from './setupTab/TabCustomer';
import TabProfile from './setupTab/TabProfile';
import TabDelivery from './setupTab/TabDelivery';
import TabNotifications from './setupTab/TabNotifications';
import { useLocation } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';

const ChevronIconNavigation = ({ nameOfClass }) => (
    <svg className={nameOfClass} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 6.37 12" width="8" height="16">
        <g id="a"></g>
        <g id="b">
            <g id="c">
                <path className="d" d="M6.23,5.52L.85,.15C.66-.05,.34-.05,.15,.15S-.05,.66,.15,.85L5.29,6,.15,11.15c-.2,.2-.2,.51,0,.71,.1,.1,.23,.15,.35,.15s.26-.05,.35-.15L6.23,6.48c.13-.13,.17-.31,.12-.48,.04-.17,0-.35-.12-.48Z"></path>
            </g>
        </g>
    </svg>
);

const getTabName = (activeTab) => {
    switch(activeTab) {
    case SETUP_TAB_PROFILE: return 'Профиль';
    case SETUP_TAB_CUSTOMER: return 'Покупатель';
    case SETUP_TAB_DELIVERY: return 'Доставка';
    case SETUP_TAB_NOTIFICATIONS: return 'Уведомления';
    default: return 'Настройки';
    }
};

const SetupPage = ({ isCollapsed, defaultCustomer, setDefaultCustomer }) => {
    const [activeSetupTab, setActiveSetupTab] = useState(SETUP_TAB_PROFILE);
    const [userId, setUserId] = useState('');
    const tabsListRef = useRef(null);
    const navigate = useNavigate();
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const resetCode = searchParams.get('code');

    const succesCallback = (response) => {
        setUserId(response.id);
    };

    useEffect(()=> {
        getFetchRequest(makeUrl([GET_CURRENT_USER]), succesCallback, errorCallback);
    },[]);

    // Center active tab on mobile when tab changes
    useEffect(() => {
        const container = tabsListRef.current;
        if (!container) return;
        const activeEl = container.querySelector('.tab-title__item_active');
        if (!activeEl) return;
        // only when overflow exists and for small screens
        if (container.scrollWidth <= container.clientWidth) return;
        if (window && window.matchMedia && !window.matchMedia('(max-width: 600px)').matches) return;

        const containerRect = container.getBoundingClientRect();
        const activeRect = activeEl.getBoundingClientRect();
        const currentLeft = container.scrollLeft;
        const targetLeft = currentLeft + (activeRect.left + activeRect.width / 2) - (containerRect.left + containerRect.width / 2);
        container.scrollTo({ left: targetLeft, behavior: 'smooth' });
    }, [activeSetupTab]);

    return (
        <section className={`workspace workspace_align ${isCollapsed===null ? '': isCollapsed? 'workspace_collapsed' : 'workspace_full-width'}`}>
            <div className="setup-tab">
                <ul className="tab-title__list" ref={tabsListRef}>
                    <li className={`tab-title__item ${activeSetupTab===SETUP_TAB_PROFILE? 'tab-title__item_active':''} navigation-link`} onClick={() => setActiveSetupTab(SETUP_TAB_PROFILE)}>Профиль</li>
                    <li className={`tab-title__item ${activeSetupTab===SETUP_TAB_CUSTOMER? 'tab-title__item_active':''} navigation-link`} onClick={() => setActiveSetupTab(SETUP_TAB_CUSTOMER)}>Покупатель</li>
                    <li className={`tab-title__item ${activeSetupTab===SETUP_TAB_DELIVERY? 'tab-title__item_active':''} navigation-link`} onClick={() => setActiveSetupTab(SETUP_TAB_DELIVERY)}>Доставка</li>
                    <li className={`tab-title__item ${activeSetupTab===SETUP_TAB_NOTIFICATIONS? 'tab-title__item_active':''} navigation-link`} onClick={() => setActiveSetupTab(SETUP_TAB_NOTIFICATIONS)}>Уведомления</li>
                </ul>
                <div className="tab-content">
                    {activeSetupTab===SETUP_TAB_PROFILE? <TabProfile resetCode={resetCode} />:''}
                    {activeSetupTab===SETUP_TAB_CUSTOMER? <TabCustomer defaultCustomer={defaultCustomer} setDefaultCustomer={setDefaultCustomer} userId={userId}/>:''}
                    {activeSetupTab===SETUP_TAB_NOTIFICATIONS? <TabNotifications userId={userId}/> : ''}
                    {activeSetupTab===SETUP_TAB_DELIVERY? <TabDelivery userId={userId}/> : ''}
                </div>
            </div>
        </section>
    );
};

export default SetupPage;